import Alpine from 'alpinejs'
 
window.Alpine = Alpine

Alpine.start()

console.log(process.env.MY_ENVIRONMENT)